import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...props }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'flex min-h-[80px] w-full rounded-md border bg-white px-3 py-2 text-sm text-ink-900',
        'placeholder:text-ink-400 border-ink-200',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lavender-400 focus-visible:border-lavender-300',
        'disabled:cursor-not-allowed disabled:bg-ink-100 disabled:text-ink-500',
        'transition-colors resize-y',
        invalid && 'border-rose-300 focus-visible:ring-rose-300',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
